<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="180px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">月份(必填)</span>
          </label>
          <el-date-picker v-model="editData.Budgettime" type="month" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用分类(必填)</span>
          </label>
          <el-input v-model="editData.Budgettype" placeholder="请输入费用分类"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用描述(必填)</span>
          </label>
          <el-input type="textarea" rows="3" v-model="editData.Budgetdetail" placeholder="请输入费用描述"></el-input>
        </el-form-item>
        <el-form-item label="单位(选填)" class="addAdminForm">
          <el-input v-model="editData.Budgetdanwei" placeholder="请输入单位"></el-input>
        </el-form-item>
        <el-form-item label="数量(选填)" class="addAdminForm">
          <el-input v-model="editData.Budgetnum" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item label="单价(选填)" class="addAdminForm">
          <el-input v-model="editData.Budgetprice" placeholder="请输入单价"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">预算金额(必填)</span>
          </label>
          <el-input v-model="editData.Budgetamount" placeholder="请输入预算金额"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">实际支出(必填)</span>
          </label>
          <el-input v-model="editData.Budgetrealspending" placeholder="请输入实际支出"></el-input>
        </el-form-item>
        <el-form-item label="供应商名称(选填)" class="addAdminForm">
          <el-input v-model="editData.Budgetsuppliername" placeholder="请输入供应商名称"></el-input>
        </el-form-item>
        <el-form-item label="备注(选填)" class="addAdminForm">
          <el-input v-model="editData.Budgetbeizhu" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {}
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.editData = parentdata
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditWorkdepartmentbudget()
    },
    apiEditWorkdepartmentbudget: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workdepartmentbudgetid: that.editData.Id,
        budgettime: that.editData.Budgettime,
        budgettype: that.editData.Budgettype,
        budgetdetail: that.editData.Budgetdetail,
        budgetdanwei: that.editData.Budgetdanwei,
        budgetnum: that.editData.Budgetnum,
        budgetprice: that.editData.Budgetprice,
        budgetamount: that.editData.Budgetamount,
        budgetrealspending: that.editData.Budgetrealspending,
        budgetsuppliername: that.editData.Budgetsuppliername,
        budgetbeizhu: that.editData.Budgetbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditWorkdepartmentbudget, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
